import React from "react";
import "./reminders-icon.css";

function RemindersIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19.002"
        height="21.233"
        viewBox="0 0 19.002 21.233"
      >
        <defs></defs>
        <g transform="translate(-1.796 -0.892)">
          <path
            className="reminders"
            d="M3.714,22.125H18.88A1.919,1.919,0,0,0,20.8,20.207V4.758A1.92,1.92,0,0,0,18.88,2.84H15.523V1.851a.959.959,0,1,0-1.918,0V2.84H9.648V1.851a.959.959,0,0,0-1.918,0V2.84H3.714A1.92,1.92,0,0,0,1.8,4.758V20.207A1.919,1.919,0,0,0,3.714,22.125Zm0-17.367H7.731v.989a.959.959,0,1,0,1.918,0V4.758h3.956v.989a.959.959,0,1,0,1.918,0V4.758H18.88V20.207H3.714Z"
            transform="translate(0 0)"
          />
          <path
            className="reminders"
            d="M15.277,9.975,9.71,15.541l-2-2.3A.959.959,0,0,0,6.26,14.5l2.677,3.078a.963.963,0,0,0,.691.328.2.2,0,0,0,.034,0,.957.957,0,0,0,.678-.281l6.294-6.3a.959.959,0,0,0-1.356-1.356Z"
            transform="translate(-0.173 -0.36)"
          />
        </g>
      </svg>
    </>
  );
}

export default RemindersIcon;
